import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CMA_SUPPORT_URL } from '../apiConfig'

export const fetchDepartment = createAsyncThunk(
  'fetchDepartment',
  async ({ jwtBearer, ticket_number }) => {
    const response = await fetch(`${CMA_SUPPORT_URL}get/ticket/department/?ticket_number=${ticket_number}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const CMADepartmentSlice = createSlice({
  name: 'CMADepartmentSlice',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchDepartment.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchDepartment.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchDepartment.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default CMADepartmentSlice.reducer
